import { type Developer, devApi } from "../developer/api";

export async function registerBiometricCredential(): Promise<string | null> {
  try {
    const body = await devApi<{ token?: string }>("/api/auth/biometric/register", {
      method: "POST",
      body: "{}",
    });
    return typeof body.token === "string" && body.token.trim() ? body.token : null;
  } catch {
    return null;
  }
}

export async function revokeBiometricCredential(): Promise<void> {
  try {
    await devApi("/api/auth/biometric/revoke", { method: "POST", body: "{}" });
  } catch {
    /* Local disable must still succeed if the API is unreachable. */
  }
}

export async function loginWithBiometricToken(token: string): Promise<{ developer: Developer; csrfToken: string; sessionToken?: string }> {
  return devApi<{ developer: Developer; csrfToken: string; sessionToken?: string }>("/api/auth/biometric/login", {
    method: "POST",
    body: JSON.stringify({ token }),
  });
}
